module.exports = __webpack_public_path__ + "img/No_Product@2x.dd12bb35.png";